import React, { useEffect, useState } from "react";
import { backend_url } from "../App";
import FabricForm from "../Components/FabricForm/FabricForm";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./CSS/FabricDatabase.css";

const stockStatus = (qty) => {
  const n = Number(qty) || 0;
  if (n <= 0) return { label: "Out of Stock", cls: "fab-stock-out" };
  if (n < 20) return { label: "Low Stock", cls: "fab-stock-low" };
  return { label: "In Stock", cls: "fab-stock-in" };
};

const FabricDatabase = () => {
  const [fabrics, setFabrics] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedId, setSelectedId] = useState(undefined); // undefined = closed, null = new
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchFabrics();
  }, []);

  const fetchFabrics = async (query = "") => {
    setLoading(true);
    try {
      const res = await fetch(`${backend_url}/api/fabrics${query ? `?search=${encodeURIComponent(query)}` : ""}`);
      const data = await res.json();
      setFabrics(data.success ? data.fabrics : []);
    } catch {
      setFabrics([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    const v = e.target.value;
    setSearch(v);
    fetchFabrics(v);
  };

  const handleDelete = async (id, e) => {
    e.stopPropagation();
    if (!window.confirm("Remove this fabric from the database?")) return;
    try {
      const res = await fetch(`${backend_url}/api/fabrics/${id}`, { method: "DELETE" });
      const data = await res.json();
      if (!data.success) throw new Error();
      toast.success("Fabric removed");
      setFabrics((prev) => prev.filter((f) => f._id !== id));
    } catch {
      toast.error("Failed to remove fabric");
    }
  };

  return (
    <div className="fabric-page">
      <div className="fabric-header">
        <div className="fabric-title-group">
          <h2 className="fabric-title">🧵 Fabric Database</h2>
          <span className="fabric-count-badge">{fabrics.length} fabrics</span>
        </div>

        <div className="fabric-search-wrap">
          <span className="fabric-search-icon">🔍</span>
          <input
            type="text"
            placeholder="Search by type, colour, print or supplier..."
            value={search}
            onChange={handleSearch}
          />
        </div>

        <button className="fabric-add-btn" onClick={() => setSelectedId(null)}>+ Add Fabric</button>
      </div>

      {loading ? (
        <p className="fabric-empty-msg">Loading…</p>
      ) : fabrics.length === 0 ? (
        <div className="fabric-empty-msg">
          <div className="fabric-empty-icon">🧵</div>
          No fabrics yet — click "Add Fabric" to register your first one.
        </div>
      ) : (
        <div className="fabric-grid">
          {fabrics.map((f) => {
            const stock = stockStatus(f.stockQuantity);
            return (
              <div key={f._id} className="fabric-card" onClick={() => setSelectedId(f._id)}>
                <div className="fabric-card-img-wrap">
                  {f.images?.[0] ? (
                    <img src={f.images[0]} alt={f.fabricType} className="fabric-card-img" />
                  ) : (
                    <div className="fabric-card-img-placeholder">No Image</div>
                  )}
                  <span className={`fabric-stock-badge ${stock.cls}`}>{stock.label}</span>
                  <button className="fabric-del-btn" onClick={(e) => handleDelete(f._id, e)} title="Remove">✕</button>
                </div>
                <div className="fabric-card-body">
                  <div className="fabric-card-top">
                    <span className="fabric-card-id">{f.fabricId}</span>
                    <span className="fabric-card-cost">{f.costPerUnit ? `₹${f.costPerUnit}` : "—"}</span>
                  </div>
                  <h4 className="fabric-card-type">{f.fabricType}</h4>
                  <div className="fabric-card-meta">
                    {f.colour && <span>{f.colour}</span>}
                    {f.gsm && <span>{f.gsm} GSM</span>}
                    {f.width && <span>{f.width}</span>}
                  </div>
                  {f.printCategory && <span className="fabric-print-pill">{f.printCategory}</span>}
                  <div className="fabric-card-stock">{f.stockQuantity ?? 0} {f.unit || "meters"} in stock</div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {selectedId !== undefined && (
        <FabricForm
          fabricId={selectedId}
          onClose={() => setSelectedId(undefined)}
          onSaved={() => fetchFabrics(search)}
        />
      )}
      <ToastContainer position="top-right" autoClose={2500} />
    </div>
  );
};

export default FabricDatabase;
